import CustomizableAutoComplete from "Global/Components/CommonComponents/CustomizableAutoComplete/CustomizableAutoComplete";
import EditableCustomizableAutoComplete from "Global/Components/EditableComponents/EditableCustomizableAutoComplete/EditableCustomizableAutoComplete";
import { StructureAnswersForSelectables } from "Global/Components/Generators/FormElementCreatorByType/Functions/StructureAnswersForSelectables";
import i18next from "i18next";
import React from "react";

const TernaryEditComboBox = ({ field, element, onChange }) => {


  console.log('field.value--->',field.value)

  return (
    <React.Fragment>
      {field.value ? (
        <EditableCustomizableAutoComplete
          onChange={onChange}
          SelectableDataArray={StructureAnswersForSelectables(
            element?.ElsRecord?.ListDefaultAnswer,
            "ComboBox"
          )}
          label={element?.LablelNameForWeb}
          completeOutPut={true}
          defaultValue={field?.UiValue?.Value}
          isEnglish={i18next.language === "en"}
        />
      ) : (
        <CustomizableAutoComplete
          onChange={onChange}
          SelectableDataArray={StructureAnswersForSelectables(
            element?.ElsRecord?.ListDefaultAnswer,
            "ComboBox"
          )}
          label={element?.LablelNameForWeb}
          completeOutPut={true}
          isEnglish={i18next.language === "en"}
        />
      )}
    </React.Fragment>
  );
};

export default TernaryEditComboBox;
